/**
 * Created by will on 6/30/14.
 */
var rolloverWizard = angular.module('rolloverWizard', ['classy']);
rolloverWizard.classy.controller({
    name: 'RolloverWizardController',
    inject: ['$scope', '$modalInstance', 'SchoolModelService', 'BinFactory', '$http', '$filter',
        'FeeAgreementModelService', 'authServiceFactory', 'FirstRunTrackingModelService'],
    init: function () {
        this.$.$modalInstance = this.$modalInstance;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.currentDiv = this.div;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.feeinfo = this.FeeAgreementModelService.get()[0];
        this.$.BinFactory = this.BinFactory;
        this.$.applength = 0;  
        this.$.bin = [];
        var parent = this;
        this.$http.get("/api/school/" + this.authServiceFactory.getAuth().schoolID +  "/archive").then( function(results) {
            var archivebin = results.data;

            for (var i = 0; i < archivebin.applications.length; i++) {
                if (((archivebin.applications[i].Status_New == 1) || (archivebin.applications[i].Status_Viewed == 1) || (archivebin.applications[i].Status_Consider == 1)) && archivebin.applications[i].Status_Appeal==0 && archivebin.applications[i].App_Fin_Year == parent.$.schoolinfo.lastLogin_FinYear) {
                    parent.$.applength++
                    parent.$.bin.push(archivebin.applications[i]);
                }
            }  
        });
        this.$.neweula = {};
        
        this.$.currentMonth = '';
        this.$.taxFilter = '';
        this.$.binFilter = '';
        if (this.$.schoolinfo.Year_End === 12) {
            this.$.newdate = 1;
        }
        else {
            this.$.newdate = this.$.schoolinfo.Year_End + 1;
        }
        this.$.checkAll = 0;

        switch (this.$.schoolinfo.Year_End) {
            case 1:
                this.$.currentMonth = "February";
                break;
            case 2:
                this.$.currentMonth = "March";
                break;
            case 3:
                this.$.currentMonth = "April";
                break;
            case 4:
                this.$.currentMonth = "May";
                break;
            case 5:
                this.$.currentMonth = "June";
                break;
            case 6:
                this.$.currentMonth = "July";
                break;
            case 7:
                this.$.currentMonth = "August";
                break;
            case 8:
                this.$.currentMonth = "September";
                break;
            case 9:
                this.$.currentMonth = "October";
                break;
            case 10:
                this.$.currentMonth = "November";
                break;
            case 11:
                this.$.currentMonth = "December";
                break;
            case 12:
                this.$.currentMonth = "January";
                break;
        }

        this.$.page = 0;
    },
    yearChange: function(newdate)
    {
        var parent = this;
        this.SchoolModelService.put(this.authServiceFactory.getAuth().schoolID, {'Year_End': newdate}).then(function() {
            parent.$.BinFactory.retrieveData();
            parent.$modalInstance.dismiss();
        });  
    },
    endProcess: function() {
        const putObject = {
            eula: this.$.neweula.eula,
            eula_date: this.$.neweula.eula_date,
            initials: this.$.neweula.initials,
            lastLogin_FinYear: (parseInt(this.$.schoolinfo.lastLogin_FinYear) + 1),
            Free_Vouchers: parseInt(this.$.feeinfo.numberVouchers)
        };
        return this.$http.put(`/api/school/${this.authServiceFactory.getAuth().schoolID}/rollover`, putObject)
            .then(() => {
                this.BinFactory.retrieveData();
                this.$.page = 7;
            });
    },
    allChecked: function(value)
    {
        this.$.checkAll = value;
        if (value == 1) {
            for (var i = 0; i < this.$.bin.length; i++) {
                if (this.$.bin[i]['Status_Award']!=1 && this.$.bin[i]['Status_Reject']!=1 && this.$.bin[i]['Status_Appeal']!=1) {
                    this.$.bin[i].selected = 1;
                }
            }
        }
        else {
            for (var i = 0; i < this.$.bin.length; i++) {
                this.$.bin[i].selected = 0;
            }
        }
    },
    famSelected: function() 
    {
        var trues = this.$filter("filter")( this.$.bin, {selected:1} );
        return trues.length;
    },
    appFinish: function() {
        let putObject = {};
        for (let i = 0; i < this.$.bin.length; i++) {
            if (this.$.bin[i].selected == 1) {
                putObject[this.$.bin[i].applicationID] = 1;
            }
        }
        if (Object.keys(putObject).length === 0) {
            return this.endProcess();
        }
        return this.$http.put(`/api/school/${this.authServiceFactory.getAuth().schoolID}/unfinished`, putObject)
            .then(() => {
                this.endProcess();
            });
    },
    nextPage: function(num)
    {
        if (num==undefined)
            this.$.page++;
        else
            this.$.page = num; 
    },
    prevPage: function()
    {
        if (this.$.page==2) 
            this.$.page = 0;
        else 
            this.$.page--;  
    },
    getCurrentPage: function()
    {
        return "fast/submodules/schoolside/rolloverWizard/partials/page" + this.$.page + ".html";
    },
    eulaPrint: function() {
        var mywindow = window.open('', 'Eula', 'height=500,width=800');
        mywindow.document.write('<html><head><title>Eula</title>');
        mywindow.document.write('</head><body>');
        mywindow.document.write($(".scroll-well").html());
        mywindow.document.write('</body></html>');

        mywindow.print();
        mywindow.close();

        return true;
    },
    agree: function()
    {
        if(this.$.neweula.eula == 1)
        {
            this.$.neweula.now = true;
            this.$.neweula.eula_date = new Date().getDateMySqlFormatted();
        }
        else
        {
            delete this.$.neweula.now;
            this.$.neweula.eula_date = '0000-00-00';
        }
    }

});

rolloverWizard.service('RolloverWizardModalService', function($modal, authServiceFactory){

    var result = {}
    result.initModal = function()
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/rolloverWizard/rolloverWizard.html?v=" + versionNo,
            controller: "RolloverWizardController",
            backdrop: 'static',
            keyboard: false

        });
    }
    return result;
});